/**
 * OTP Agrár Nyeremény játék fő vezérlő komponenes
 *
 * @author Erik Bánhalmi @2017.01.12.
 */
import template from './nyeremenyjatek.pug';
import nyeremenyjatekServiceModule from './nyeremenyjatek-service';
const MODULE_NAME = 'nyeremenyjatek';
class NyeremenyjatekController {
	constructor(nyeremenyjatekService) {
		'ngInject';
		this._nyeremenyJatekService = nyeremenyjatekService;
	}
	$onInit() {
		this.visibleModule = {
			subscribe: true,
			quiz: false,
			summary: false
		};
		this.captcha = this._nyeremenyJatekService.getCaptchaUrl();
	}
	//feliratkozás komponenes callbackje
	subscribe(object) {
		this._nyeremenyJatekService.subscribe(object.model, object.captcha).then((response) => {
			let responseObject = response.$response();
			if (responseObject.status == 200) {
				this.visibleModule.subscribe = false;
				this.visibleModule.quiz = true;
				this.email = object.model.email;
			}
		}, (err) => {
			if (err.data.errors.length > 0) {
				this.subscribeErrors = err.data.errors;
				this.captcha = this._nyeremenyJatekService.getCaptchaUrl();
			}
		});
	}
	// válaszok komponenes callbackje
	submitQuiz(object) {
		this.submitQuizData = object.model;
		this.submitQuizData.email = this.email;
		this._nyeremenyJatekService.submitQuiz(this.submitQuizData).then(() => {
			this.visibleModule.quiz = false;
			this.visibleModule.summary = true;
		}, (err) => {
			this.technicalError = err;
		});
	}
}

export default angular.module(MODULE_NAME, [nyeremenyjatekServiceModule])
	.component('nyeremenyjatek', {
		controller: NyeremenyjatekController,
		template: template()
	}).name;



// WEBPACK FOOTER //
// ./source/applications/nyeremenyjatek/nyeremenyjatek.js